import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListNovedades from './Components/ListNovedades';
import NovedadNew from './Components/NovedadNew';

export default class AdmNovedades extends React.Component {

  render() {
    return (
      <div>
        <Routes>
          <Route path="" element={<ListNovedades/>}/>
          <Route path="Nueva" element={<NovedadNew/>}/>
        </Routes>
      </div>
    );
  }
}